
import Header from '~/components/common/Header.vue';
import Footer from '~/components/common/Footer.vue';

import PopUpRedirect from '~/components/modals/PopUpRedirect.vue';
import {
  AppMixin,
  CartMixin,
  CategoriesListMixin,
  CmsMetaMixin,
  CmsMixin,
  UserAuthMixin,
  UserMixin,
  WishlistMixin,
} from '~/node_modules/sitis-nuxt/lib/mixins';
import { metaData } from '~/helpers/meta-data';

export default {
  name: 'LayoutDefault',

  data() {
    return {};
  },

  components: {
    PopUpRedirect,
    PopUpCallback: () => import('~/components/modals/PopUpCallback.vue'),
    PopUpAuthorization: () => import('~/components/modals/PopUpAuthorization.vue'),
    Header,
    Footer,
    PopUpCitySelect: () => import('~/components/modals/PopUpCitySelect'),
    // LazyDialogFastBuy: () => import('~/components/catalog/LazyDialogFastBuy.vue'),
    LazyModalLoading: () => import('~/components/common/LazyModalLoading.vue'),
    TelegramFixed: () => import('~/components/common/TelegramFixed.vue'),
    PopupCallPrice: () => import('~/components/modals/PopUpCallPrice.vue'),
    PopupCallbackSmeta: () => import('~/components/modals/PopUpSmeta.vue'),
    PopUpNotification: () => import('~/components/modals/PopUpNotification.vue'),
    WhatsappBtn: () => import('~/components/widgets/WhatsappBtn/WhatsappBtn.vue'),
    PopUpBuyOneClick: () => import('~/components/modals/PopUpBuyOneClick.vue'),
    PopUpImages: () => import('~/components/modals/PopUpImages.vue'),
  },

  mixins: [
    AppMixin,
    UserMixin,
    UserAuthMixin,
    CartMixin,
    CmsMetaMixin,
    CmsMixin,
    WishlistMixin,
    CategoriesListMixin,
  ],

  computed: {
    isOpenBuyOneClickPopup() {
      return this.$store.getters['pop-up-buy-one-click/isOpen'];
    },
    isOpenAuthoriz() {
      return this.$store.state?.authRegistration?.isOpenAuth || false;
    },
    isOpenCitySelect() {
      return this.$store.state['city-select']?.isOpen || false;
    },
    isOpenRedirectPopup() {
      return this.$store.state['pop-up-redirect']?.isOpen;
    },
    isOpenNotificationModal() {
      return this.$store.state['pop-up-notification']?.isOpen;
    },
    isOpenCallback() {
      return this.$store.state['pop-up-back-call']?.callbackPopup.isOpen;
    },
    isOpenCallPrice() {
      return this.$store.state['pop-up-back-call']?.callPrice.isOpen;
    },
    isOpenSmetaModal() {
      return this.$store.state['pop-up-smeta']?.isOpen;
    },
    setCustomCatalog() {
      return this.$store.getters['custom-catalog/catalogList'];
    },

    isOpenModalLoading() {
      return this.$store.getters['loading/loading'];
    },

    isAdvContent() {
      return this.$store.state.currentPhone.isAdvContent;
    },

    headerMetaAsync() {
      const vars = this.$store.state?.appState?.vars;
      const config = this.$store.state?.appState?.config;
      const headMeta = config?.head?.meta || [];

      let meta = [];
      headMeta.forEach((item) => {
        meta.push(
          { name: item.name, content: item.content },
        );
      });
      meta = [
        ...meta,
        ...metaData({
          logoLink: this?.appCfg?.logoFront || '',
          pageSlug: this.$route.fullPath || '',
          pageTitle: this?.page?.page?.title || '',
          pageDescription: this?.page?.page?.description || '',
        }),
      ];

      if (vars?.googlebot) {
        meta.push({ name: "googlebot", content: vars?.googlebot });
      }

      return meta;
    },

    countersFooter() {
      return this.appCfg?.counters?.footer || '';
    },

    footerMenu() {
      // Получить меню можно двумя способами(должна быть подключена миксина CmsMixin)
      // const allMenus = this.allCmsMenus;
      // const footer['footer'].items as any[];
      const footerMenu = this.getCmsMenu('footer');
      return footerMenu?.items || [];
    },

    isMenuOpened() {
      return this.$store.getters['mobile-menu/isOpen'];
    },
  },

  async fetch() {
    await this.getMenu();
    await this.currentPhone();
    // await this.getUser();
    // await this.getCatalog();
    await this.$store.dispatch('custom-catalog/setCatalogList');
  },

  head() {
    const meta = this.headerMetaAsync;

    return {
      titleTemplate: `%s ${this.appCfg?.suffixDivider || ''} ${
        this.appCfg?.suffixTitle || ''
      }`,
      meta: [...meta],
      script: [
        {type: 'text/javascript', innerHTML: `var _mtm = window._mtm = window._mtm || [];_mtm.push({ 'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start' });(function () {var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];g.src = 'https://stat1.clickfraud.ru/js/container_GVzdhvrK.js'; s.parentNode.insertBefore(g, s);})();`}
      ]
    };
  },

  watch: {
    isMenuOpened() {
      this.blockBody();
    },
  },

  methods: {
    checkSubDomain: function () {
      let host = window?.location?.host || '';
      const cityName = this.$store.state?.appState?.config?.city?.model?.name || '';
      if (!!cityName || host.indexOf('localhost') > -1) {
        return;
      }

      host = host.split('.');
      if (host.length === 3) {
        host.shift();
      }
      host = host.join('.');
      window.location.host = host;
    },

    async currentPhone() {
      const vars = this.vars?.['Рекламные теги'].split(', ');
      const adsPhone = this.vars?.['Телефон для переходов с рекламы'];
      const route = this?.$route?.query;
      let isAdvFlag = false;
      let phone = this.vars?.['бесплатный телефон'];

      Object.entries(route).forEach(([key, values]) => {
        if (vars.includes(key)) {
          phone = adsPhone;
          isAdvFlag = true;
        }
      });

      if (isAdvFlag) {
        this.$store.commit('currentPhone/setAdvContent', true);
        await this.getAdvContent();
      }

      this.$store.commit('currentPhone/setCurrentPhone', phone);
    },

    async getAdvContent() {
      const res = await this.$api.agent.transport
        .get('config/adv?adv=1')
        .then((res) => res.data)
        .catch((err) => {
          console.log('adv content error:', err.response);
          return {
            error: 'not correctly',
          };
        });
    },

    onResize() {
      const isMobile = window.innerWidth < 1023;
      this.$store.commit('mobile-menu/isMobileScreen', isMobile);
    },

    blockBody() {
      if (this.isMenuOpened) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
    openPopUpRedirect() {
      const queryParams = new URLSearchParams(window.location.search);
      const hasFromParam = queryParams.get('from') === 'pdn89';

      if (hasFromParam) {
        setTimeout(() => {
          this.$store.commit('pop-up-redirect/openPopup', {
            yandexMetriks: {
              ymGoal: 'sendform89',
              ymNumber: process.env.yandexMetriks,
            },
          });
        }, 10000);
      }
    },
  },

  async mounted() {
    this.checkSubDomain();
    this.openPopUpRedirect();
    await this.getCart();

    this.onResize();
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.onResize);
  },

};
